export default "__VITE_ASSET__CKm7PUeu__"